<template>
    <div class="row">
        <div v-for="ebook in ebooks" :key="ebook.id" class="col-lg-4 col-md-6 wow move-up">
            <div class="service-grid">
                <div class="ht-service-box--two text-center">
                    <router-link :to="'/'">
                        <div class="image mb-20">
                            <img :src="ebook.icon" class="img-fluid" :alt="ebook.alt" loading="lazy">
                        </div>
                        <div class="content">
                            <h6 class="sub-heading">{{ ebook.subheading }}</h6>
                            <h6 class="ht-heading mb-15">{{ $t(ebook.heading) }}</h6>
                            <div class="service_text">{{ $t(ebook.text) }}</div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'EbookFeature',
        data (){
            return {
                ebooks: [
                    {
                        icon: require('../assets/img/icons/aeroland-ebook-box-image-02.png'), 
                        alt:'aeroland-ebook-box-image-02', 
                        heading:'webgelistirme', 
                        subheading:'01', 
                        text:'Teknik uzmanlarımız, müşterilerin ihtiyaçlarına göre temiz kodlanmış ve kesintisiz web siteleri geliştirme konusunda yeteneklidir'
                    },
                    {
                        icon: require('../assets/img/icons/aeroland-ebook-box-image-01.png'),
                        alt:'aeroland-ebook-box-image-01', 
                        heading:'uygulamagelistirme', 
                        subheading:'02', 
                        text:'Teknik uzmanlarımız, müşterilerin ihtiyaçlarına göre hızlı ve kullanımı kolay uygulama geliştirme konusunda yeteneklidir'
                    },
                    {
                        icon: require('../assets/img/icons/aeroland-ebook-box-image-03.png'), 
                        alt:'aeroland-ebook-box-image-03', 
                        heading:'satispazarlama', 
                        subheading:'03', 
                        text:'Satış uzmanlarımız, müşterilerin ihtiyaçlarına göre hazırlanan uygulamaları satış pazarlama konusunda yeteneklidir'
                    },
                    {
                        icon: require('../assets/img/icons/aeroland-ebook-box-image-04.png'), 
                        alt:'aeroland-ebook-box-image-04', 
                        heading:'arastirma', 
                        subheading:'04', 
                        text:'Teknik uzmanlarımız, müşterilerin ihtiyaçlarına göre ihtiyaç duyulan yapıyı bulma ve kurulum konusunda yeteneklidir'
                    },
                    {
                        icon: require('../assets/img/icons/aeroland-ebook-box-image-05.png'), 
                        alt:'aeroland-ebook-box-image-05', 
                        heading:'magazacilik', 
                        subheading:'05', 
                        text:'Teknik uzmanlarımız, müşterilerin ihtiyaçlarına uygun mağaza kurulumu ve uygulamaları konusunda yeteneklidir'
                    },
                    {
                        icon: require('../assets/img/icons/aeroland-ebook-box-image-06.png'), 
                        alt:'aeroland-ebook-box-image-06', 
                        heading:'egitimdestek', 
                        subheading:'06', 
                        text:'Teknik uzmanlarımız, müşterilerin ihtiyaçlarına göre geliştirilen uygulamaları eğitim ve destek konusunda yeteneklidir'
                    },
                ]
            }
        }
    }
</script>
